/**
 * @typedef {Object} TaxesAndSalesFieldConfig
 * @property {string} key Field key used to read the value from each item.
 * @property {string} label Display label for the field.
 * @property {(item: Object) => string|number|boolean|null|undefined} [formatValue] Optional formatter for composite values.
 */

/**
 * @typedef {Object} TaxesAndSalesSectionConfig
 * @property {string} id Unique section id.
 * @property {string} title Section title.
 * @property {string} source Array key on product data.
 * @property {string} itemLabel Label prefix for each item in the list.
 * @property {TaxesAndSalesFieldConfig[]} fields Fields rendered for each item.
 */

/**
 * Taxes section configuration used by the Tax & Sales tab.
 * @type {TaxesAndSalesSectionConfig}
 */
export const PRODUCT_REVIEW_TAXES_SECTION = {
  id: 'taxes',
  title: 'Taxes',
  source: 'taxes',
  itemLabel: 'Tax',
  fields: [
    {key: 'taxTypeCode', label: 'Tax Type Code'},
    {key: 'taxCountryCode', label: 'Tax Country Code'},
    {key: 'taxCode', label: 'Tax Code'},
    {key: 'taxName', label: 'Tax Name'},
  ],
}

/**
 * Sale UoMs section configuration used by the Tax & Sales tab.
 * @type {TaxesAndSalesSectionConfig}
 */
export const PRODUCT_REVIEW_SALE_UOMS_SECTION = {
  id: 'sale-uoms',
  title: 'Sale UoMs',
  source: 'saleUoms',
  itemLabel: 'Sale UoM',
  fields: [
    {
      key: 'code',
      label: 'Code',
      formatValue: item => {
        if (item?.code && item?.name) return `${item.code} (${item.name})`
        if (item?.code) return `${item.code} (-)`
        if (item?.name) return `- (${item.name})`
        return '-'
      },
    },
    {key: 'upc', label: 'UPC'},
    {key: 'baseUomConversionNumerator', label: 'Base UOM Conversion Numerator'},
    {key: 'baseUomConversionDenominator', label: 'Base UOM Conversion Denominator'},
  ],
}

export const PRODUCT_REVIEW_TAXES_AND_SALES_SECTIONS = [PRODUCT_REVIEW_TAXES_SECTION, PRODUCT_REVIEW_SALE_UOMS_SECTION]
